import { DownloadOutlined } from '@ant-design/icons';
import {
  Button, Modal, QRCode, Space, Typography
} from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface QrCodeModalProps {
  qrCode: string;
  handleClose: () => void;
}
const QrCodeModal: React.FC<QrCodeModalProps> = (
  { qrCode, handleClose }
) => {
  const { t } = useTranslation();
  const downloadQRCode = () => {
    const canvas = document.getElementById('qrCode')?.querySelector<HTMLCanvasElement>('canvas');
    if (canvas) {
      const url = canvas.toDataURL();
      const a = document.createElement('a');
      a.download = 'QRCode.png';
      a.href = url;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  };
  return (
    <Modal
      title={(
        <Typography.Title
          level={4}
          style={{ textAlign: 'center' }}
        >
          QR Code Link
        </Typography.Title>
      )}
      open={!!qrCode}
      closable={false}
      footer={null}
      centered
    >
      <div id="qrCode" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <QRCode value={qrCode} size={300} />
        <Space style={{ width: '100%', justifyContent: 'flex-end', marginTop: 20 }}>
          <Button onClick={downloadQRCode}>
            <DownloadOutlined />
            {t('program.downloadQrCode')}
          </Button>
          <Button
            type="primary"
            onClick={handleClose}
          >
            OK
          </Button>
        </Space>
      </div>
    </Modal>
  );
};

export default QrCodeModal;
